import { createApi } from "@reduxjs/toolkit/query/react";
import RtkBaseQueryWithReauth from "./RtkBaseQueryWithReauth";
import ApiPath from './ConstantApi';
import { setCategory, setRefillCategory } from "../Redux/Slices/SettingSlice";
import { Category } from "../Helpers/Interfaces/CategoryType";
import Config from "../Config";
import Constant from "../Config/Constant";

// Create the API slice
export const CategoryService = createApi({
  reducerPath: "CategorieApis",
  baseQuery: RtkBaseQueryWithReauth(Config.BASE_URL),
  tagTypes: ["Categories"],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getCategoryList: builder.query<Category[], void>({
      query: () => ({
        url: ApiPath.cotegoryList,
        method: "GET",
      }),
      transformResponse: (response: { data: Category[] }) => response.data,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data }:any = await queryFulfilled; // Wait for the query to resolve
          if(data && Array.isArray(data) && data.length > 0){
            const filteredData:any = data.filter((item: Category) => item?.parentCategoryName === Constant.PARENT_CATEGORY_NAME.GIFT_CARDS || item?.parentCategoryName ===Constant.PARENT_CATEGORY_NAME.GAMING)
            dispatch(setCategory(filteredData)); // Dispatch setUser with the fetched user data
            const refillFilteredData: any = data.filter((item: Category) => item?.parentCategoryName === Constant.PARENT_CATEGORY_NAME.PHONE_REFILL);
            dispatch(setRefillCategory(refillFilteredData));
          }
        } catch (error) {
          console.error('Error fetching user:', error);
        }
      },
      providesTags: ["Categories"],
    }),
    getCategoryListById: builder.query<any, string>({
      query: (id) => ({
        url: `${ApiPath.categoriesListById}/${id}`,
        method: "GET",
      }),
    }),
    
  }),
});

// Export hooks for the API
export const {
  useGetCategoryListQuery,
  useLazyGetCategoryListByIdQuery
} = CategoryService;
  